//Built-in libraries
import type { ColumnDef } from '@tanstack/react-table';
import { useState } from 'react';

//Custom components
import Table from '../../../UI/Table';

//Services

//Assets and Miscellaneous

const ImpactByCounty = () => {
  const [perPage, setPerPage] = useState<number>(10);
  const [page, setPage] = useState<number>(1);
  const [totalPage, _setTotalPage] = useState<number>(1);

  const data: any = [
    {
      countyCode: '1',
      countyName: 'Allegany',
      totalGrants: '$ 550,000',
      totalProjects: '8',
    },
    {
      countyCode: '2',
      countyName: 'Anne Arundel',
      totalGrants: '$ 2,727,273',
      totalProjects: '10',
    },
    {
      countyCode: '3',
      countyName: 'Baltimore City',
      totalGrants: '$ 132,500',
      totalProjects: '5',
    },
    {
      countyCode: '4',
      countyName: 'Baltimore County',
      totalGrants: '$ 3,929,000',
      totalProjects: '10',
    },
    {
      countyCode: '5',
      countyName: 'Calvert',
      totalGrants: '$ 119,000',
      totalProjects: '8',
    },
    {
      countyCode: '6',
      countyName: 'Caroline',
      totalGrants: '$ 139,500',
      totalProjects: '15',
    },
  ];

  const nextPageHandler = () => {
    setPage((prevState) => (prevState === totalPage ? totalPage : page + 1));
  };

  const previousPageHandler = () => {
    setPage((prevState) => (prevState > 1 ? page - 1 : 1));
  };

  const tableColumns: ColumnDef<any>[] = [
    {
      id: 'countyCode',
      header: 'County Code',
      accessorKey: 'countyCode',
      cell: (props) => {
        const { getValue } = props;
        return getValue() as string;
      },
    },
    {
      id: 'countyName',
      header: () => <div className='text-center'>County Name</div>,
      accessorKey: 'countyName',
      cell: (props) => {
        const { getValue } = props;
        return (
          <div className='text-center'>
            <span>{getValue() as string}</span>
          </div>
        );
      },
    },
    {
      id: 'totalGrants',
      header: () => <div className='text-center'>Total Grants</div>,
      accessorKey: 'totalGrants',
      cell: (props) => {
        const { getValue } = props;
        return (
          <div className='text-center'>
            <span>{getValue() as string}</span>
          </div>
        );
      },
    },
    {
      id: 'totalProjects',
      header: () => <div className='text-center'>Total Projects</div>,
      accessorKey: 'totalProjects',
      cell: (props) => {
        const { getValue } = props;
        return (
          <div className='text-center'>
            <span>{getValue() as string}</span>
          </div>
        );
      },
    },
  ];

  const tablePagination = {
    page: page,
    pageSize: perPage,
    pageCount: totalPage,
    currentPage: page,
    setPageSize: (v: number) => setPerPage(v),
    nextPage: nextPageHandler,
    previousPage: previousPageHandler,
  };

  return (
    <div className='h-full w-full'>
      <div className='flex flex-row  bg-white justify-start items-center rounded-t-md py-4'>
        <h3 className='font-bold text-bold border-l-4 p-4 border-green-500 capitalize'>Impact By County</h3>

        <div className='pr-2 text-neutralColor-light cursor-pointer hover:text-neutralColor-medium transition duration-300 ease-in-out'></div>
      </div>
      <div className='h-96 border rounded-b-md w-full'>
        <Table cols={tableColumns} tableData={data} pagination={tablePagination} />
      </div>
    </div>
  );
};

export default ImpactByCounty;
